import { useSearchParams } from "react-router-dom";
import { PageHeader } from "../components/shared";
import POTemplate from "./POTemplate";
import POEmailTemplate from "../components/POEmailTemplate";

const TABS = [{ id: "po", label: "PO Template", C: POTemplate }, { id: "email", label: "PO Email Template", C: POEmailTemplate }];

export default function OrderTemplates() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.find((t) => t.id === params.get("tab")) || TABS[0];
  return (
    <div>
      <PageHeader kicker="// ORDERING · DOCUMENTS & MESSAGES" title="Order Templates">
        {TABS.map((t) => (
          <button key={t.id} data-testid={`order-templates-tab-${t.id}`} onClick={() => setParams({ tab: t.id })}
            className={`h-12 px-5 rounded-md text-sm font-semibold border ${tab.id === t.id ? "bg-white text-[#090D16]" : "border-[#334155] text-[#9CA3AF]"}`}>{t.label}</button>
        ))}
      </PageHeader>
      <tab.C />
    </div>
  );
}
